import * as React from 'react'

/**
 * @description PoundExchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PoundExchange } from '@sravni/design-system-icons'
 *
 * <PoundExchange />
 * ```
 */
export const PoundExchange = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="PoundExchange" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#PoundExchange__a)" stroke="currentColor">
      <path
        d="M9.346 1.047a7.223 7.223 0 0 0-4.112 1.62l-.347-.36A7.722 7.722 0 0 1 9.346.545v.502Zm1-.502c3.762.236 6.784 3.105 7.042 6.705h-.501c-.257-3.31-3.046-5.97-6.541-6.204v-.5Zm6.54 7.705h.5a6.977 6.977 0 0 1-.077.633l-.463-.111.03-.122h-.037c.02-.133.035-.266.046-.4ZM10.526 14.953a7.223 7.223 0 0 0 4.112-1.621l.351.364a7.75 7.75 0 0 1-4.463 1.758v-.501Zm-1 0v.501c-3.763-.235-6.785-3.097-7.042-6.704h.501c.257 3.31 3.045 5.97 6.54 6.203ZM2.986 7.75h-.501c.016-.215.043-.426.078-.634l.465.112-.033.132h.036c-.019.129-.034.259-.045.39ZM1.576 7.273l-.353-.353.433-.433.177.176.176.177-.433.433ZM4.21 6.92l-.353.353-.433-.433.177-.177.176-.176.433.433ZM18.644 8.975l-.428.428-.176-.177-.177-.176.428-.428.353.353Zm-2.628-.358.433.433-.177.176-.176.177-.433-.433.353-.353Z"
        fill="currentColor"
      />
      <path
        d="M12.166 4.17c-1.27-.51-2.55-.32-3.16.43-.13.16-.34.48-.4 1l.07 4.06c-.52.69-.74 1.16-1.26 1.85h5.25"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.936 7.65h4.65" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="PoundExchange__a">
        <path fill="currentColor" transform="translate(.296 .03)" d="M0 0h19.28v15.94H0z" />
      </clipPath>
    </defs>
  </svg>
))
